import { credentialIdAtomDefinition, lockedAtomDefinition, lockHistoryAtomDefinition, restoreAtomDefinition, walletCreatedAtAtomDefinition, } from './atoms.js';
import applicationDefinition from './module.js';
import applicationLifecyclePluginDefinition from './plugin.js';
export { LifecycleHook } from './constants.js';
const application = () => {
    return {
        id: 'application',
        definitions: [
            { definition: applicationDefinition },
            {
                definition: lockedAtomDefinition,
            },
            {
                definition: restoreAtomDefinition,
            },
            {
                definition: lockHistoryAtomDefinition,
            },
            {
                definition: walletCreatedAtAtomDefinition,
            },
            {
                definition: applicationLifecyclePluginDefinition,
            },
            {
                definition: credentialIdAtomDefinition,
                storage: { namespace: 'flags' },
                aliases: [
                    { interfaceId: 'storage', implementationId: 'unsafeStorage' },
                ],
            },
        ],
    };
};
export default application;
